let breedOptions = [
  'Mixed / Other...',
  'Affenpinscher',
  'Afghan Hound',
  'Africanis',
  'Aidi',
  'Airedale Terrier',
  'Akbash',
  'Akita',
  'Aksaray Malaklisi',
  'Alano Español',
  'Alapaha Blue Blood Bulldog',
  'Alaskan husky',
  'Alaskan Klee Kai',
  'Alaskan Malamute',
  'Alopekis',
  'Alpine Dachsbracke',
  'American Bulldog',
  'American Bully',
  'American Cocker Spaniel',
  'American English Coonhound',
  'American Eskimo Dog',
  'American Foxhound',
  'American Hairless Terrier',
  'American Pit Bull Terrier',
  'American Staffordshire Terrier',
  'American Water Spaniel',
  'Andalusian Hound',
  'Anglo-Français de Petite Vénerie',
  'Appenzeller Sennenhund',
  'Ariegeois',
  'Armant',
  'Armenian Gampr dog',
  'Artois Hound',
  'Australian Cattle Dog',
  'Australian Kelpie',
  'Australian Shepherd',
  'Australian Stumpy Tail Cattle Dog',
  'Australian Terrier',
  'Austrian Black and Tan Hound',
  'Austrian Pinscher',
  'Azawakh',
  'Bakharwal dog',
  'Banjara Hound',
  'Barbado da Terceira',
  'Barbet',
  'Basenji',
  'Basque Shepherd Dog',
  'Basset Artésien Normand',
  'Basset Bleu de Gascogne',
  'Basset Fauve de Bretagne',
  'Basset Hound',
  'Bavarian Mountain Hound',
  'Beagle',
  'Beagle-Harrier',
  'Belgian Shepherd',
  'Bearded Collie',
  'Beauceron',
  'Bedlington Terrier',
  'Bergamasco Shepherd',
  'Berger Picard',
  'Bernese Mountain Dog',
  'Bichon Frisé',
  'Billy',
  'Black and Tan Coonhound',
  'Black Norwegian Elkhound',
  'Black Russian Terrier',
  'Black Mouth Cur',
  'Bloodhound',
  'Blue Lacy',
  'Blue Picardy Spaniel',
  'Bluetick Coonhound',
  'Boerboel',
  'Bohemian Shepherd',
  'Bolognese',
  'Border Collie',
  'Border Terrier',
  'Borzoi',
  'Bosnian Coarse-haired Hound',
  'Boston Terrier',
  'Bouvier des Ardennes',
  'Bouvier des Flandres',
  'Boxer',
  'Boykin Spaniel',
  'Bracco Italiano',
  "Braque d'Auvergne",
  "Braque de l'Ariège",
  'Braque du Bourbonnais',
  'Braque Francais',
  'Braque Saint-Germain',
  'Briard',
  'Briquet Griffon Vendéen',
  'Brittany',
  'Broholmer',
  'Bruno Jura Hound',
  'Brussels Griffon',
  'Bucovina Shepherd Dog',
  'Bull Arab',
  'Bull Terrier',
  'Bulldog',
  'Bullmastiff',
  'Bully Kutta',
  'Burgos Pointer',
  'Ca Mè Mallorquí',
  'Cairn Terrier',
  'Ca Mè Mallorquí',
  'Campeiro Bulldog',
  'Can de Chira',
  'Can de Palleiro',
  'Canaan Dog',
  'Canadian Eskimo Dog',
  'Cane Corso',
  'Cane di Oropa',
  'Cane Paratore',
  'Cantabrian Water Dog',
  'Cão da Serra de Aires',
  'Cão de Castro Laboreiro',
  'Cão de Gado Transmontano',
  'Cão Fila de São Miguel',
  'Cardigan Welsh Corgi',
  'Carea Castellano Manchego',
  'Carea Leonés',
  'Carolina Dog',
  'Carpathian Shepherd Dog',
  'Catahoula Leopard Dog',
  'Catalan Sheepdog',
  'Caucasian Shepherd Dog',
  'Cavalier King Charles Spaniel',
  'Central Asian Shepherd Dog',
  'Cesky Fousek',
  'Cesky Terrier',
  'Chesapeake Bay Retriever',
  'Chien Français Blanc et Noir',
  'Chien Français Blanc et Orange',
  'Chien Français Tricolore',
  'Chihuahua',
  'Chilean Terrier',
  'Chinese Crested Dog',
  'Chinook',
  'Chippiparai',
  'Chongqing dog',
  'Chortai',
  'Chow Chow',
  'Cimarrón Uruguayo',
  "Cirneco dell'Etna",
  'Clumber Spaniel',
  'Colombian fino hound',
  'Coton de Tulear',
  'Cretan Hound',
  'Croatian Sheepdog',
  'Curly-Coated Retriever',
  'Cursinu',
  'Czechoslovakian Wolfdog',
  'Dachshund',
  'Dalmatian',
  'Dandie Dinmont Terrier',
  'Danish Spitz',
  'Danish-Swedish Farmdog',
  'Denmark Feist',
  'Dingo',
  'Doberman Pinscher',
  'Dogo Argentino',
  'Dogo Guatemalteco',
  'Dogo Sardesco',
  'Dogue Brasileiro',
  'Dogue de Bordeaux',
  'Drentse Patrijshond',
  'Drever',
  'Dunker',
  'Dutch Shepherd',
  'Dutch Smoushond',
  'East Siberian Laika',
  'East European Shepherd',
  'Ecuadorian Hairless Dog',
  'English Cocker Spaniel',
  'English Foxhound',
  'English Mastiff',
  'English Setter',
  'English Shepherd',
  'English Springer Spaniel',
  'English Toy Terrier (Black & Tan)',
  'Entlebucher Mountain Dog',
  'Estonian Hound',
  'Estrela Mountain Dog',
  'Eurasier',
  'Field Spaniel',
  'Fila Brasileiro',
  'Finnish Hound',
  'Finnish Lapphund',
  'Finnish Spitz',
  'Flat-Coated Retriever',
  'French Bulldog',
  'French Spaniel',
  'Galgo Español',
  'Garafian Shepherd',
  'Gascon Saintongeois',
  'Georgian Shepherd',
  'German Hound',
  'German Longhaired Pointer',
  'German Pinscher',
  'German Roughhaired Pointer',
  'German Shepherd Dog',
  'German Shorthaired Pointer',
  'German Spaniel',
  'German Spitz',
  'German Wirehaired Pointer',
  'Giant Schnauzer',
  'Glen of Imaal Terrier',
  'Golden Retriever',
  'Gończy Polski',
  'Gordon Setter',
  'Grand Anglo-Français Blanc et Noir',
  'Grand Anglo-Français Blanc et Orange',
  'Grand Anglo-Français Tricolore',
  'Grand Basset Griffon Vendéen',
  'Grand Bleu de Gascogne',
  'Grand Griffon Vendéen',
  'Great Dane',
  'Greater Swiss Mountain Dog',
  'Greek Harehound',
  'Greek Shepherd',
  'Greenland Dog',
  'Greyhound',
  'Griffon Bleu de Gascogne',
  'Griffon Fauve de Bretagne',
  'Griffon Nivernais',
  'Gull Dong',
  'Gull Terrier',
  'Hällefors Elkhound',
  'Halden Hound',
  'Hamiltonstövare',
  'Hanover Hound',
  'Harrier',
  'Havanese',
  'Himalayan Sheepdog',
  'Hierran Wolfdog',
  'Hokkaido',
  'Hovawart',
  'Huntaway',
  'Hygen Hound',
  'Ibizan Hound',
  'Icelandic Sheepdog',
  'Indian pariah dog',
  'Indian Spitz',
  'Irish Red and White Setter',
  'Irish Setter',
  'Irish Terrier',
  'Irish Water Spaniel',
  'Irish Wolfhound',
  'Istrian Coarse-haired Hound',
  'Istrian Shorthaired Hound',
  'Italian Greyhound',
  'Jack Russell Terrier',
  'Jagdterrier',
  'Japanese Chin',
  'Japanese Spitz',
  'Japanese Terrier',
  'Jindo',
  'Jonangi',
  'Kai Ken',
  'Kaikadi',
  'Kangal Shepherd Dog',
  'Kanni',
  'Karakachan dog',
  'Karelian Bear Dog',
  'Kars',
  'Karst Shepherd',
  'Keeshond',
  'Kerry Beagle',
  'Kerry Blue Terrier',
  'Khala',
  'King Charles Spaniel',
  'King Shepherd',
  'Kintamani',
  'Kishu',
  'Kokoni',
  'Kombai',
  'Komondor',
  'Kooikerhondje',
  'Koolie',
  'Koyun dog',
  'Kromfohrländer',
  'Kuchi',
  'Kuvasz',
  'Labrador Retriever',
  'Lagotto Romagnolo',
  'Lakeland Terrier',
  'Lancashire Heeler',
  'Landseer',
  'Lapponian Herder',
  'Large Münsterländer',
  'Leonberger',
  'Levriero Sardo',
  'Lhasa Apso',
  'Lithuanian Hound',
  'Löwchen',
  'Lupo Italiano',
  'Mackenzie River husky',
  'Magyar agár',
  'Mahratta Greyhound',
  'Maltese',
  'Manchester Terrier',
  'Maneto',
  'Maremmano-Abruzzese Sheepdog',
  'McNab dog',
  'Miniature American Shepherd',
  'Miniature Bull Terrier',
  'Miniature Fox Terrier',
  'Miniature Pinscher',
  'Miniature Schnauzer',
  'Molossus of Epirus',
  'Montenegrin Mountain Hound',
  'Mountain Cur',
  'Mountain Feist',
  'Mucuchies',
  'Mudhol Hound',
  'Mudi',
  'Neapolitan Mastiff',
  'New Guinea singing dog',
  'New Zealand Heading Dog',
  'Newfoundland',
  'Norfolk Terrier',
  'Norrbottenspets',
  'Northern Inuit Dog',
  'Norwegian Buhund',
  'Norwegian Elkhound',
  'Norwegian Lundehund',
  'Norwich Terrier',
  'Nova Scotia Duck Tolling Retriever',
  'Old Croatian Sighthound',
  'Old Danish Pointer',
  'Old English Sheepdog',
  'Old English Terrier',
  'Olde English Bulldogge',
  'Otterhound',
  'Pachon Navarro',
  'Pampas Deerhound',
  'Paisley Terrier',
  'Papillon',
  'Parson Russell Terrier',
  'Pastore della Lessinia e del Lagorai',
  'Patagonian Sheepdog',
  'Patterdale Terrier',
  'Pekingese',
  'Pembroke Welsh Corgi',
  'Perro Majorero',
  'Perro de Pastor Mallorquin',
  'Perro de Presa Canario',
  'Perro de Presa Mallorquin',
  'Peruvian Inca Orchid',
  'Petit Basset Griffon Vendéen',
  'Polish Greyhound',
  'Polish Hound',
  'Polish Lowland Sheepdog',
  'Polish Tatra Sheepdog',
  'Pomeranian',
  'Pont-Audemer Spaniel',
  'Poodle',
  'Porcelaine',
  'Portuguese Podengo',
  'Portuguese Pointer',
  'Portuguese Water Dog',
  'Posavac Hound',
  'Pražský Krysařík',
  'Pshdar dog',
  'Pudelpointer',
  'Petit Bleu de Gascogne',
  'Phalène',
  'Pharaoh Hound',
  'Phu Quoc Ridgeback',
  'Picardy Spaniel',
  'Plummer Terrier',
  'Plott Hound',
  'Podenco Canario',
  'Podenco Valenciano',
  'Pointer',
  'Poitevin',
  'Pug',
  'Puli',
  'Pumi',
  'Pungsan dog',
  'Pyrenean Mastiff',
  'Pyrenean Mountain Dog',
  'Pyrenean Sheepdog',
  'Rafeiro do Alentejo',
  'Rajapalayam',
  'Rampur Greyhound',
  'Rat Terrier',
  'Ratonero Bodeguero Andaluz',
  'Ratonero Mallorquin',
  'Ratonero Murciano',
  'Ratonero Valenciano',
  'Redbone Coonhound',
  'Rhodesian Ridgeback',
  'Romanian Mioritic Shepherd Dog',
  'Romanian Raven Shepherd Dog',
  'Rottweiler',
  'Rough Collie',
  'Russian Spaniel',
  'Russian Toy',
  'Russo-European Laika',
  'Ryukyu Inu',
  'Saarloos Wolfdog',
  'Sabueso Español',
  'Saint Bernard',
  'Saint Hubert Jura Hound',
  'Saint-Usuge Spaniel',
  'Saluki',
  'Samoyed',
  'Sapsali',
  'Sarabi dog',
  'Sardinian Shepherd Dog',
  'Šarplaninac',
  'Schapendoes',
  'Schillerstövare',
  'Schipperke',
  'Schweizer Laufhund',
  'Schweizerischer Niederlaufhund',
  'Scottish Deerhound',
  'Scottish Terrier',
  'Sealyham Terrier',
  "Segugio dell'Appennino",
  'Segugio Italiano',
  'Segugio Maremmano',
  'Serbian Hound',
  'Serbian Tricolour Hound',
  'Serrano Bulldog',
  'Shar Pei',
  'Shetland Sheepdog',
  'Shiba Inu',
  'Shih Tzu',
  'Shikoku',
  'Shiloh Shepherd',
  'Siberian Husky',
  'Silken Windhound',
  'Silky Terrier',
  'Sinhala Hound',
  'Skye Terrier',
  'Sloughi',
  'Slovakian Wirehaired Pointer',
  'Slovenský Cuvac',
  'Slovenský Kopov',
  'Smalandstövare',
  'Small Greek domestic dog',
  'Small Münsterländer',
  'Smooth Collie',
  'Smooth Fox Terrier',
  'Soft-Coated Wheaten Terrier',
  'South Russian Ovcharka',
  'Spanish Mastiff',
  'Spanish Water Dog',
  'Spinone Italiano',
  'Sporting Lucas Terrier',
  'Stabyhoun',
  'Staffordshire Bull Terrier',
  'Standard Schnauzer',
  'Stephens Stock',
  'Styrian Coarse-haired Hound',
  'Sussex Spaniel',
  'Swedish Elkhound',
  'Swedish Lapphund',
  'Swedish Vallhund',
  'Swedish White Elkhound',
  'Taigan',
  'Taiwan Dog',
  'Tamaskan Dog',
  'Tazy',
  'Teddy Roosevelt Terrier',
  'Telomian',
  'Tenterfield Terrier',
  'Terrier Brasileiro',
  'Thai Bangkaew Dog',
  'Thai Ridgeback',
  'Tibetan Kyi Apso',
  'Tibetan Mastiff',
  'Tibetan Spaniel',
  'Tibetan Terrier',
  'Torkuz',
  'Tornjak',
  'Tosa',
  'Toy Fox Terrier',
  'Toy Manchester Terrier',
  'Transylvanian Hound',
  'Treeing Cur',
  'Treeing Feist',
  'Treeing Tennessee Brindle',
  'Treeing Walker Coonhound',
  'Trigg Hound',
  'Tyrolean Hound',
  'Vikhan',
  'Villano de Las Encartaciones',
  'Villanuco de Las Encartaciones',
  'Vizsla',
  'Volpino Italiano',
  'Weimaraner',
  'Welsh Sheepdog',
  'Welsh Springer Spaniel',
  'Welsh Terrier',
  'West Country Harrier',
  'West Highland White Terrier',
  'West Siberian Laika',
  'Westphalian Dachsbracke',
  'Wetterhoun',
  'Whippet',
  'White Shepherd',
  'White Swiss Shepherd Dog',
  'Wire Fox Terrier',
  'Wirehaired Pointing Griffon',
  'Wirehaired Vizsla',
  'Xiasi Dog',
  'Xoloitzcuintle',
  'Yakutian Laika',
  'Yorkshire Terrier',
  'Zerdava'
];

const monthLookup = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

const html = document.querySelector('html');
const selectModal = document.querySelector('.pet-selector-drawer');
let emptyMessage = selectModal.querySelector('.pet-list-empty');
let selectedCount;

// PDP Hidden inputs
let namePropInput = document.getElementById('ip--dog-name');

// Find all modal open triggers and construct array for event listener
let openTriggers = [];
let nameTrigger = document.getElementById('name-trigger');
if (nameTrigger) {
  openTriggers.push(nameTrigger);
}
let editPackTriggers = document.querySelectorAll('.edit-pack-button');
if (editPackTriggers.length > 0) {
  editPackTriggers.forEach((trigger) => {
    openTriggers.push(trigger);
  });
}
let packTriggers = document.querySelectorAll('.show-pack-drawer');
if (packTriggers.length > 0) {
  packTriggers.forEach((trigger) => {
    openTriggers.push(trigger);
  });
}

// Buttons
let selectBtn = document.getElementById('select-pet');
let addBtn = document.getElementById('add-pet');
let closeTrigger = document.getElementById('close-pet-drawer');
let addForm = document.getElementById('create-pet');
let addFirst = document.getElementById('add-first');
let deleteConfirm = document.getElementById('delete-confirm-panel');

// Reset new pet form
function resetAddForm() {
  addForm.reset();
  addForm.querySelector('.weight-int').textContent = '50';
}

function getCurrentAge(petBirthday) {
  const birthDate = new Date(petBirthday);
  const currentDate = new Date();
  let years = currentDate.getFullYear() - birthDate.getFullYear();
  let months = currentDate.getMonth() - birthDate.getMonth();
  // If current month is less than birth month, then decrement year and calculate months
  if (
    months < 0 ||
    (months === 0 && currentDate.getDate() < birthDate.getDate())
  ) {
    years--;
    months = (months + 12) % 12;
  }
  // Correct the months when the current date is less than the birth date
  if (currentDate.getDate() < birthDate.getDate()) {
    months--;
    if (months < 0) {
      months += 12; // wrap around the month value if negative
    }
  }
  // Construct the age string
  let ageString = `${years > 0 ? `${years} ${years === 1 ? 'Year' : 'Years'}` : ''}${years > 0 && months > 0 ? ', ' : ''}${months > 0 ? `${months} ${months === 1 ? 'Month' : 'Months'}` : ''}`;
  // Edge case for brand new pets
  if (ageString === '') {
    ageString = 'Just Born';
  }
  return ageString + ' Old';
}

// If customer and on account page add event listeners for edit buttons
function initPageEdits() {
  if (!customerId) return;
  document.querySelectorAll('.account--edit-pet').forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      showDrawer();
      let id = this.getAttribute('data-edit-pet');
      let target = selectModal.querySelector(
        `.pet-selector[data-pet-id="${id}"] .pet-edit-button`
      );
      target.click();
    });
  });
}

initPageEdits();

// Range actions
function rangeInit() {
  let rangeSliders = document.querySelectorAll('input[type=range]');
  let valuePreviews = document.querySelectorAll('.weight-int');
  for (let i = 0; i < rangeSliders.length; i++) {
    let rangeSlider = rangeSliders[i];
    let valuePreview = valuePreviews[i];
    rangeSlider.addEventListener('input', function () {
      if (valuePreview) {
        valuePreview.textContent = rangeSlider.value;
      } else {
        let wrapper = rangeSlider.closest('.form-field-group');
        let previewElement = wrapper.querySelector('.weight-int');
        if (previewElement) {
          previewElement.textContent = rangeSlider.value;
        }
      }
    });
  }
}

// Close drawer
function closeDrawer() {
  selectModal.classList.remove('show-tip', 'show-init');
  if (document.querySelectorAll('.modal-displayed').length === 0) {
    html.classList.replace('js-drawer-open', 'js-drawer-closing');
    html.classList.remove('lock-scroll');
    setTimeout(() => {
      html.classList.remove('js-drawer-closing');
    }, 300);
  }
  if (outsideClickHandler) {
    document.removeEventListener('click', outsideClickHandler);
    outsideClickHandler = null;
  }
}

closeTrigger.addEventListener('click', closeDrawer);

document.addEventListener('keydown', function (event) {
  const petDrawer = document.querySelector('.pet-selector-drawer');
  if (
    event.key === 'Escape' &&
    petDrawer &&
    petDrawer.classList.contains('show-init')
  ) {
    closeDrawer();
  }
});

let outsideClickHandler = null;

function showDrawer() {
  selectModal.classList.add('show-init', 'show-tip');
  html.classList.add('js-drawer-open', 'lock-scroll');
  const options = selectModal.querySelectorAll(
    '.pet-name-option:not(.placeholder-option)'
  );
  if (options.length === 0 && emptyMessage) {
    emptyMessage.classList.remove('hidden');
  }

  // Add outside click listener after a short delay to prevent race condition
  setTimeout(() => {
    outsideClickHandler = function (e) {
      const drawer = document.querySelector('.pet-selector-drawer');
      if (drawer && !drawer.contains(e.target)) {
        closeDrawer();
      }
    };
    document.addEventListener('click', outsideClickHandler);
  }, 100);
}

function delayShowDrawer() {
  setTimeout(showDrawer, 200);
}

// Set select button state
function setSelectState() {
  if (selectBtn) {
    selectBtn.disabled = false;
    selectedCount = document.querySelectorAll('.pet-selected').length;
    if (selectedCount === 0) {
      selectBtn.textContent = 'Continue without selection';
    } else {
      selectBtn.textContent = 'Select';
    }
  }
}

// Delete pets actions
function deletePet() {
  let deleteButtons = selectModal.querySelectorAll(
    '[data-action="form-edit-delete"]'
  );
  deleteButtons.forEach((deleteButton) => {
    deleteButton.addEventListener('click', function (e) {
      e.preventDefault();
      deleteConfirm.classList.add('show-form');
      // Ensuring event handlers are not repeatedly attached
      let confirmDeletion = document.getElementById('delete-confirm');
      let cancelDeletion = document.getElementById('delete-cancel');
      // Using a one-time event listener to avoid multiple bindings
      confirmDeletion.onclick = function () {
        performDeletion(deleteButton);
      };
      cancelDeletion.onclick = function () {
        deleteConfirm.classList.remove('show-form');
      };
    });
  });
}

function performDeletion(deleteButton) {
  let optionId = deleteButton.closest('form').id.replace('edit-', '');
  let option = deleteButton.closest('.pet-name-option');
  option.remove();
  updateLocalStorage(optionId);
  updateUI(optionId);
  deleteConfirm.classList.remove('show-form');
  document.dispatchEvent(new Event('petSelection:delete'));
}

function updateLocalStorage(optionId) {
  let originalPetJson = JSON.parse(
    localStorage.getItem('petProfiles') || '{"pets":[]}'
  );
  let updatedPetList = originalPetJson.pets.filter(
    (pet) => pet.id !== optionId
  );
  localStorage.setItem('petProfiles', JSON.stringify({ pets: updatedPetList }));
}

function updateUI(optionId) {
  let pageOption = document.querySelector(
    `.account--pet-item-wrap[data-pet-id="${optionId}"]`
  );
  if (pageOption) {
    let wrapper = pageOption.closest('.address-grid-wrap');
    wrapper.classList.add('mb0');
    pageOption.remove();
  }
  let emptyMessage = document.querySelector('.account-pets-empty');
  if (emptyMessage && !document.querySelector('.account--pet-item-wrap')) {
    emptyMessage.classList.remove('hide');
  }
  editListener();
  checkboxListener();
  reparseOptions();
  saveActions();
  setSelectState();
  profileSync();
}

// Reset ID's when options added or removed
function reparseOptions() {
  let options = document.querySelectorAll(
    '.checkbox-wrap:not(.placeholder-option)'
  );
  if (options.length > 0) {
    emptyMessage.classList.add('hidden');
    for (let i = 0; i < options.length; i++) {
      let option = options[i];
      option.id = 'option-' + i;
      let checkboxInput = option.querySelector('.pet-selector');
      let checkboxLabel = option.querySelector('.checkbox-label');
      let editBtn = option.querySelector('.pet-edit-button');
      let saveBtn = option.querySelector('.save-pet-edits');
      let cancelBtn = option.querySelector('.cancel-pet-edits');
      let appendId = '-' + i;
      let radios = option.querySelectorAll('.js-radio--input');
      let radioLabels = option.querySelectorAll('.js-radio--label');
      for (let i = 0; i < radios.length; i++) {
        let radio = radios[i];
        let label = radioLabels[i];
        if (!radio.id.includes(appendId)) {
          radio.id = radio.id + appendId;
        }
        if (!label.getAttribute('for').includes(appendId)) {
          label.setAttribute('for', label.getAttribute('for') + appendId);
        }
      }
      let newId = 'box-' + i;
      checkboxInput.id = newId;
      checkboxInput.name = newId;
      checkboxLabel.setAttribute('for', newId);
      editBtn.id = 'edit-box-' + i;
      saveBtn.id = 'save-pet-' + i;
      cancelBtn.id = 'cancel-pet-' + i;
    }
  } else {
    emptyMessage.classList.remove('hidden');
  }
}

function handleOutsideClick() {}
// Unique ID generator
function createId() {
  let result = '';
  let characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  for (var i = 0; i < 8; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// Save buttons
function saveActions() {
  let saveButtons = document.querySelectorAll('[data-action="form-save"]');
  saveButtons.forEach((saveButton) => {
    let wrap;
    saveButton.addEventListener('click', function (e) {
      e.preventDefault();
      let form = saveButton.closest('form');
      // Hide error message
      let errors = form.querySelectorAll('.add-error-message');
      let nameError = errors[0];
      let breedError = errors[1];
      nameError.classList.remove('input-error');
      breedError?.classList.remove('input-error');
      // Validate form
      let petName = form.querySelector('[name="pet-name"]').value;
      let petBreed = form.querySelector('.pet-breed-input').value;
      if (!petName) {
        nameError.classList.add('input-error');
      }
      if (!breedOptions.includes(petBreed)) {
        breedError?.classList.add('input-error');
      }
      if (petName && breedOptions.includes(petBreed)) {
        // Get values from form
        let petWeight = form.querySelector('[name="pet-weight"]').value;
        let birthdayMonth = form.querySelector(
          '[name="pet-birthday-month"]'
        ).value;
        let birthdayYear = form.querySelector(
          '[name="pet-birthday-year"]'
        ).value;
        let petBirthday = birthdayMonth + '/01/' + birthdayYear;
        let petAge = getCurrentAge(petBirthday);
        let petActivity = form.querySelector(
          '[name="activity-level"]:checked'
        ).value;
        let petGender = form.querySelector('[name="gender"]:checked').value;
        let petSpayNeuter = form.querySelector(
          '[name="spayed-neutered"]:checked'
        ).value;

        // If add form, create a new option
        if (form.id === 'create-pet') {
          let parent = document.querySelector('.pet-names-list');
          let original = document.getElementById('option-blank');
          let newItem = original.cloneNode(true);
          parent.appendChild(newItem);
          let newElement = document.querySelectorAll('.placeholder-option');
          newElement = newElement[newElement.length - 1];
          newElement.classList.remove('placeholder-option');
          wrap = newElement;
          reparseOptions();
          toggleAddPane();
        } else {
          wrap = form.closest('.pet-name-option');
          form.classList.remove('show-edit-form');
        }
        // Set checkbox display content
        let optionSelector = wrap.querySelector('.pet-selector');
        let optionNameDisplay = wrap.querySelector('.pet-name');
        let optionBreedDisplay = wrap.querySelector('.pet-breed');
        let optionWeightDisplay = wrap.querySelector('.pet-weight');
        let optionAgeDisplay = wrap.querySelector('.pet-age');
        optionSelector.value = petName;
        optionNameDisplay.textContent = petName;
        optionBreedDisplay.textContent = petBreed;
        optionWeightDisplay.textContent = petWeight + ' lbs';
        optionAgeDisplay.textContent = petAge;
        // Update edit form content
        let editName = wrap.querySelector('[name="pet-name"]');
        let editWeight = wrap.querySelector('[name="pet-weight"]');
        let editWeightPreview = wrap.querySelector('.weight-int');
        let editMonth = wrap.querySelector('[name="pet-birthday-month"]');
        let editYear = wrap.querySelector('[name="pet-birthday-year"]');
        editName.value = petName;
        editWeight.value = petWeight;
        editWeightPreview.textContent = petWeight;
        editMonth.value = birthdayMonth;
        editYear.value = birthdayYear;
        // Local storage updates
        let petsArray = [];
        let existingPets = JSON.parse(localStorage.getItem('petProfiles'));
        let editId;
        if (existingPets) {
          if (form.id !== 'create-pet') {
            editId = form.id;
            editId = editId.replace('edit-', '');
          }
          petsArray = existingPets.pets;
        }
        let uniqueId = editId ? editId : createId();
        let newProfile = true;
        if (editId) {
          let matchedPet = petsArray.find((pet) => pet.id === editId);
          newProfile = matchedPet ? false : true;
          if (matchedPet) {
            matchedPet.name = petName;
            matchedPet.breed = petBreed;
            matchedPet.weight = petWeight;
            matchedPet.dob_month = birthdayMonth;
            matchedPet.dob_year = birthdayYear;
            matchedPet.activity = petActivity ? petActivity : null;
            matchedPet.gender = petGender ? petGender : null;
            matchedPet.spayed_neutered = petSpayNeuter ? petSpayNeuter : null;
          }
        }
        if (newProfile) {
          petsArray.push({
            id: uniqueId,
            name: petName,
            breed: petBreed,
            weight: petWeight,
            dob_month: birthdayMonth,
            dob_year: birthdayYear,
            activity: petActivity ? petActivity : null,
            gender: petGender ? petGender : null,
            spayed_neutered: petSpayNeuter ? petSpayNeuter : null
          });
        }
        let profileJson = { pets: petsArray };
        let profileData = JSON.stringify(profileJson);
        localStorage.setItem('petProfiles', profileData);
        localStorage.setItem('selectedPet', uniqueId);
        // New onpage actions
        if (form.id === 'create-pet') {
          editListener();
          checkboxListener();
          resetAddForm();
          deletePet();
          saveActions();
          rangeInit();
          initBreedSelectors();
          let editForms = selectModal.querySelectorAll('.edit-pet-form');
          let index = editForms.length - 1;
          let newEditForm = editForms[index];
          newEditForm.id = 'edit-' + uniqueId;
        }
        let current = wrap.querySelector('input[type="checkbox"]');
        current.setAttribute('data-pet-id', uniqueId);
        if (current.getAttribute('data-checked') !== 'true') {
          current.click();
        }
        setSelectState();
        // If customer is logged in and on the account page update display components
        if (customerId && form.id !== 'create-pet') {
          let query = '.account--pet-item-wrap[data-pet-id="' + uniqueId + '"]';
          let panelDisplayObj = document.querySelector(query);
          if (panelDisplayObj) {
            let pageWeight = panelDisplayObj.querySelector(
              '.account-weight-display'
            );
            pageWeight.textContent = petWeight;
            let pageDob = panelDisplayObj.querySelector(
              '.account-dob-month-display'
            );
            let x = parseInt(birthdayMonth) - 1;
            let dobMonth = monthLookup[x];
            pageDob.textContent = dobMonth;
            let pageYear = panelDisplayObj.querySelector(
              '.account-dob-year-display'
            );
            pageYear.textContent = birthdayYear;
            let pageName = panelDisplayObj.querySelector(
              '.account-name-display'
            );
            pageName.textContent = petName;
            let pageBreed = panelDisplayObj.querySelector(
              '.account-breed-display'
            );
            pageBreed.textContent = petBreed;
            let pageAge = panelDisplayObj.querySelector('.account-age-display');
            let pageAgeType =
              panelDisplayObj.querySelector('.account-age-value');
            let ageYears;
            let ageMonths;
            if (petAge.includes(', ')) {
              let ageSplit = petAge.split(', ');
              ageYears = ageSplit[0];
              ageYears = ageYears.split(' ');
              ageYears = parseInt(ageYears[0]);
              ageMonths = ageSplit[1];
              ageMonths = ageMonths.split(' ');
              ageMonths = parseInt(ageMonths[0]);
            } else {
              if (petAge.includes('year') || petAge.includes('years')) {
                ageYears = petAge.split(' ');
                ageYears = parseInt(ageYears[0]);
                ageMonths = 0;
              } else {
                ageMonths = petAge.split(' ');
                ageMonths = parseInt(ageMonths[0]);
                ageYears = 0;
              }
            }
            if (ageYears !== 0) {
              let monthsDecimal;
              if (ageMonths > 2 && ageMonths < 5) {
                monthsDecimal = '.25';
              } else if (ageMonths >= 5 && ageMonths < 8) {
                monthsDecimal = '.5';
              } else if (ageMonths >= 8) {
                monthsDecimal = '.75';
              }
              let pageAgeDisplay = ageYears + monthsDecimal;
              pageAge.textContent = pageAgeDisplay;
              if (pageAgeDisplay == '1') {
                pageAgeType.textContent = 'year old';
              } else {
                pageAgeType.textContent = 'years old';
              }
            } else {
              pageAge.textContent = ageMonths;
              if (ageMonths == '1') {
                pageAgeType.textContent = 'month old';
              } else {
                pageAgeType.textContent = 'months old';
              }
            }
          }
        } else if (customerId && form.id === 'create-pet') {
          let panelCloneItem = document.querySelector(
            '.account--pet-placeholder'
          );
          if (panelCloneItem) {
            let newItem = panelCloneItem.cloneNode(true);
            newItem.classList.remove('hidden');
            newItem.classList.remove('account--pet-placeholder');
            newItem.setAttribute('data-pet-id', uniqueId);
            let newName = newItem.querySelector('.account-name-display');
            newName.textContent = petName;
            let newBreed = newItem.querySelector('.account-breed-display');
            newBreed.textContent = petBreed;
            let newEdit = newItem.querySelector('.account--edit-pet');
            newEdit.setAttribute('data-edit-pet', uniqueId);
            let newWeight = newItem.querySelector('.account-weight-display');
            newWeight.textContent = petWeight;
            let newMob = newItem.querySelector('.account-dob-month-display');
            let x = parseInt(birthdayMonth) - 1;
            let newDobMonth = monthLookup[x];
            newMob.textContent = newDobMonth;
            let newYob = newItem.querySelector('.account-dob-year-display');
            newYob.textContent = birthdayYear;
            let newAge = newItem.querySelector('.account-age-display');
            let newAgeType = newItem.querySelector('.account-age-value');
            let ageYears;
            let ageMonths;
            if (petAge.includes(', ')) {
              let ageSplit = petAge.split(', ');
              ageYears = ageSplit[0];
              ageYears = ageYears.split(' ');
              ageYears = parseInt(ageYears[0]);
              ageMonths = ageSplit[1];
              ageMonths = ageMonths.split(' ');
              ageMonths = parseInt(ageMonths[0]);
            } else {
              if (petAge.includes('year') || petAge.includes('years')) {
                ageYears = petAge.split(' ');
                ageYears = parseInt(ageYears[0]);
                ageMonths = 0;
              } else {
                ageMonths = petAge.split(' ');
                ageMonths = parseInt(ageMonths[0]);
                ageYears = 0;
              }
            }
            if (ageYears !== 0) {
              let monthsDecimal;
              if (ageMonths > 2 && ageMonths < 5) {
                monthsDecimal = '.25';
              } else if (ageMonths >= 5 && ageMonths < 8) {
                monthsDecimal = '.5';
              } else if (ageMonths >= 8) {
                monthsDecimal = '.75';
              }
              let newAgeDisplay = ageYears + monthsDecimal;
              newAge.textContent = newAgeDisplay;
              if (newAgeDisplay == '1') {
                newAgeType.textContent = 'year old';
              } else {
                newAgeType.textContent = 'years old';
              }
            } else {
              newAge.textContent = ageMonths;
              if (ageMonths == '1') {
                newAgeType.textContent = 'month old';
              } else {
                newAgeType.textContent = 'months old';
              }
            }
            let newParent = panelCloneItem.closest('.address-grid-wrap');
            newParent.classList.remove('mb0');
            newParent.appendChild(newItem);
            let emptyMessage = document.querySelector('.account-pets-empty');
            if (emptyMessage) {
              emptyMessage.classList.add('hide');
            }
            initPageEdits();
          }
        }
        if (form.id === 'create-pet') {
          let petAdded = new Event('petSelection:add');
          document.dispatchEvent(petAdded);
        } else {
          let petEdited = new Event('petSelection:edit');
          document.dispatchEvent(petEdited);
        }
      }
      profileSync();
    });
  });
}

// Hide open edit forms
function hideEditForms() {
  let visibleEditForms = document.querySelector('.show-edit-form');
  if (visibleEditForms) {
    visibleEditForms.classList.remove('show-edit-form');
  }
}

// Edit buttons click
function editListener() {
  let editBtns = document.querySelectorAll('.pet-edit-button');
  editBtns.forEach((editBtn) => {
    let wrap = editBtn.closest('.pet-name-option');
    let form = wrap.querySelector('.edit-pet-form');
    let breedValue = wrap.querySelector('.pet-breed').textContent;
    let breedInput = form.querySelector('.pet-breed-input');
    breedInput.value = breedValue;
    editBtn.addEventListener('click', function () {
      hideEditForms();
      form.classList.add('show-edit-form');
      if (selectBtn) {
        selectBtn.disabled = true;
      }
      let cancelBtn = form.querySelector('.cancel-pet-edits');
      // CANCEL button click
      cancelBtn.addEventListener('click', function (e) {
        e.preventDefault();
        form.classList.remove('show-edit-form');
        setSelectState();
      });
    });
  });
}

// Select button click
if (selectBtn) {
  selectBtn.addEventListener('click', function () {
    let mismatchMessages = document.querySelectorAll('.mismatch-notice');
    if (mismatchMessages) {
      mismatchMessages.forEach((message) => {
        message.classList.add('hidden');
      });
    }
    let selectedOption = document.querySelector(
      '.pet-selector[data-checked="true"]'
    );
    if (selectedOption) {
      let selectedValue = selectedOption.value;
      let selectedPetId = selectedOption.getAttribute('data-pet-id');
      localStorage.setItem('selectedPet', selectedPetId);
      if (nameTrigger) {
        nameTrigger.textContent = selectedValue;
        if (namePropInput) {
          namePropInput.value = selectedValue;
          namePropInput.name = 'properties[_Dog Name]';
        }
      }
      let weightFormName = document.querySelector('.form-weight-pet');
      if (weightFormName) {
        weightFormName.textContent = selectedValue;
        let selectedParent = selectedOption.closest('.pet-name-option');
        let selectedWeight = selectedParent.querySelector('.pet-weight');
        selectedWeight = selectedWeight.textContent.split(' ');
        selectedWeight = parseInt(selectedWeight[0]);
        let rangeParent = weightFormName.closest('.form-option-sim');
        let weightMismatchNames =
          rangeParent.querySelectorAll('.weight-apply-name');
        weightMismatchNames.forEach((name) => {
          name.textContent = selectedValue;
        });
        let rangeInput = rangeParent.querySelector('input[type="range"]');
        rangeInput.value = selectedWeight;
        rangeInput.setAttribute('data-selected-pet-weight', selectedWeight);
        let rangeDisplayValue = rangeParent.querySelector(
          '.weight-range-value'
        );
        rangeDisplayValue.textContent = selectedWeight;
        let change = new Event('change');
        rangeInput.dispatchEvent(change);
        if (selectedWeight > 39) {
          enableTopperOption();
        } else {
          disableTopperOption();
        }
      }
    } else {
      localStorage.removeItem('selectedPet');
      if (nameTrigger) {
        nameTrigger.textContent = 'Your dog';
        if (namePropInput) {
          namePropInput.value = '';
          namePropInput.name = '';
        }
      }
      let weightFormName = document.querySelector('.form-weight-pet');
      if (weightFormName) {
        weightFormName.textContent = 'Your dog';
      }
    }
    closeDrawer();
  });
}

// Checkbox selection event listener
function checkboxClick() {
  let wasSelected = this.getAttribute('data-checked');
  let wrap = this.closest('.checkbox-wrap');
  if (wasSelected === 'false') {
    this.setAttribute('data-checked', 'true');
    this.classList.add('pet-selected');
    wrap.classList.add('option-selected');
  } else {
    this.setAttribute('data-checked', 'false');
    this.classList.remove('pet-selected');
    wrap.classList.remove('option-selected');
  }
  let indicator = wrap.querySelector('.checkbox-action-indicator');
  indicator.classList.add('transitioning');
  setSelectState();
  if (selectedCount > 1) {
    let selectedOptions = selectModal.querySelectorAll('.pet-selected');
    for (let i = 0; i < selectedOptions.length; i++) {
      let selectedOption = selectedOptions[i];
      if (selectedOption !== this) {
        selectedOption.setAttribute('data-checked', 'false');
        selectedOption.classList.remove('pet-selected');
        selectedOption.checked = false;
        let deselectWrap = selectedOption.closest('.checkbox-wrap');
        deselectWrap.classList.remove('option-selected');
      }
    }
  }
  setTimeout(function () {
    indicator.classList.remove('transitioning');
  }, 200);
}

function checkboxListener() {
  let checkboxes = document.querySelectorAll('.pet-selector');
  checkboxes.forEach((checkbox) => {
    checkbox.removeEventListener('change', checkboxClick);
    checkbox.addEventListener('change', checkboxClick);
  });
}

// New Pet Form
let addFormWrap = document.getElementById('add-pet-panel');
let closePane = document.getElementById('close-add-pane');
let saveNew = document.getElementById('add-new-pet');
let cancelNew = document.getElementById('cancel-new-pet');

function toggleAddPane() {
  hideEditForms();
  addFormWrap.classList.toggle('show-form');
}

function cancelAdd(e) {
  e.preventDefault();
  toggleAddPane();
}

addBtn.addEventListener('click', toggleAddPane);
addFirst.addEventListener('click', toggleAddPane);
closePane.addEventListener('click', toggleAddPane);
cancelNew.addEventListener('click', cancelAdd);

if (customerId) {
  let pageAddBtns = document.querySelectorAll(
    '.add-pack-member-button, [data-action="add-pet-profile"]'
  );
  pageAddBtns.forEach((button) => {
    button.addEventListener('click', function () {
      showDrawer();
      addBtn.click();
    });
  });
}

// --------------------------------------------------------------------

// Predictive search functionality

// --------------------------------------------------------------------

let placeholderWrap = document.getElementById('list-template');
let placeholderTemp = placeholderWrap.querySelector('li');
let placeholder = placeholderTemp.cloneNode(true);
placeholderWrap.remove();

function initBreedSelectors() {
  let searchBoxes = document.querySelectorAll('.search-wrap');
  for (let i = 0; i < searchBoxes.length; i++) {
    let searchBox = searchBoxes[i];
    let input = searchBox.querySelector('.search-input');
    let resultList = searchBox.querySelector('.result-list');
    if (!resultList) continue;
    let existingResults = resultList.querySelectorAll('li');
    if (existingResults.length > 0) {
      for (let i = 0; i < existingResults.length; i++) {
        let existingResult = existingResults[i];
        existingResult.remove();
      }
    }

    // Add autofill options to all occurrences
    for (let ii = 0; ii < breedOptions.length; ii++) {
      let breedOption = breedOptions[ii];
      let newOption = placeholder.cloneNode(true);
      let optionRadio = newOption.querySelector('input[type="radio"]');
      let optionLabel = newOption.querySelector('label');
      let breedId = breedOption.toLowerCase();
      breedId = breedId.replaceAll(' ', '-');
      breedId = breedId.replaceAll('/', '-');
      breedId = breedId + '-' + i;
      optionRadio.id = breedId + '-' + ii;
      optionRadio.value = breedOption;
      optionLabel.htmlFor = breedId + '-' + ii;
      optionLabel.textContent = breedOption;
      resultList.appendChild(newOption);
      if (breedOption === 'Mixed / Other...') {
        newOption.classList.add('result-other');
        newOption.classList.remove('autofill-list-item');
        newOption
          .querySelector('input')
          .classList.remove('breed-option-autofill');
      }
    }

    // Add event listneners to each occurrence
    fillResult();
    // Round 38: when the lists are built on demand, dog-info-modal.js may already have swapped this input for its custom select.
    if (input) {
      input.addEventListener('focusout', checkResult);
      input.addEventListener('keyup', updateResults);
    }
  }
}

function updateResults(input) {
  let parent = this.closest('.search-wrap');
  let query = this.value.toLowerCase();
  let options = parent.querySelectorAll('.autofill-list-item');
  // Add matching values
  for (let i = 0; i < options.length; i++) {
    let option = options[i];
    let optionValue = option.querySelector('input').value.toLowerCase();
    if (optionValue.includes(query)) {
      option.classList.remove('hidden');
    } else {
      option.classList.add('hidden');
    }
  }
}

function fillResult() {
  let listItems = document.querySelectorAll('.breed-list-item');
  for (let i = 0; i < listItems.length; i++) {
    let item = listItems[i];
    let option = item.querySelector('label');
    let outer = option.closest('.search-wrap');
    let searchBox;
    if (outer) searchBox = outer?.querySelector('.search-input');
    option.addEventListener('mousedown', function () {
      if (searchBox) searchBox.value = option.textContent;
      let autofillBreed = new Event('fill-select');
      document.dispatchEvent(autofillBreed);
    });
  }
}

function checkResult(input) {
  let searchBox = this.closest('.search-wrap');
  let value = this.value;
  let resultError = searchBox.querySelector('.add-error-message');
  if (!breedOptions.includes(value)) {
    resultError.classList.add('input-error');
  } else {
    resultError.classList.remove('input-error');
  }
  searchBox.dispatchEvent(new Event('breed:selection'));
}

// --------------------------------------------------------------------

// Get & set savedPets from local storage data

// --------------------------------------------------------------------

let savedPets = JSON.parse(localStorage.getItem('petProfiles'));

// Metafield pets defined in theme.liquid header (for easy liquid access)
function setLocalToMeta() {
  let localPush = {};
  if (metafieldPets.length > 0) {
    localPush.pets = metafieldPets;
    localPush = JSON.stringify(localPush);
    localStorage.setItem('petProfiles', localPush);
    savedPets = JSON.parse(localStorage.getItem('petProfiles'));
  }
}

if (savedPets && metafieldPets) {
  if (savedPets.pets !== metafieldPets) {
    setLocalToMeta();
  }
}

// If local storage does not have savedPets but metafields do
if (metafieldPets && !savedPets) {
  setLocalToMeta();
}
// If there are saved pets, create selection options in drawer
if (savedPets) {
  let parent = document.querySelector('.pet-names-list');
  let original = document.getElementById('option-blank');
  let fragment = document.createDocumentFragment();
  savedPets.pets.forEach((pet) => {
    let newItem = original.cloneNode(true);
    newItem.classList.remove('placeholder-option');
    // Set checkbox display content
    let optionSelector = newItem.querySelector('.pet-selector');
    optionSelector.value = pet.name;
    newItem.querySelector('.pet-name').textContent = pet.name;
    newItem.querySelector('.pet-breed').textContent = pet.breed;
    newItem.querySelector('.pet-weight').textContent = pet.weight + ' lbs';
    newItem.querySelector('.pet-age').textContent = getCurrentAge(
      pet.dob_month + '/01/' + pet.dob_year
    );
    // Update edit form content
    let form = newItem.querySelector('form');
    form.id = 'edit-' + pet.id;
    optionSelector.setAttribute('data-pet-id', pet.id);
    let editName = newItem.querySelector('[name="pet-name"]');
    let editWeight = newItem.querySelector('[name="pet-weight"]');
    let editWeightPreview = newItem.querySelector('.weight-int');
    let editMonth = newItem.querySelector('[name="pet-birthday-month"]');
    let editYear = newItem.querySelector('[name="pet-birthday-year"]');
    if (pet.activity) {
      let activityLevel = newItem.querySelector(
        `[name="activity-level"][value="${pet.activity}"]`
      );
      if (activityLevel) {
        activityLevel.checked = true;
      }
    }
    if (pet.gender) {
      newItem.querySelector(`[name="gender"][value="${pet.gender}"]`).checked =
        true;
    }
    if (pet.spayed_neutered) {
      newItem.querySelector(
        `[name="spayed-neutered"][value="${pet.spayed_neutered}"]`
      ).checked = true;
    }
    editName.value = pet.name;
    editWeight.value = pet.weight;
    editWeightPreview.textContent = pet.weight;
    editMonth.value = pet.dob_month;
    editYear.value = pet.dob_year;
    fragment.appendChild(newItem);
  });
  parent.appendChild(fragment);
  reparseOptions();
}

// Open triggers event listener
openTriggers.forEach((trigger) => {
  trigger.addEventListener('click', showDrawer);
});

// Initialize general pet drawer functionality
rangeInit();
deletePet();
saveActions();
editListener();
// Round 38 (speed): the breed lists (526 options per search box) used to be built on page load in every
// search box on the page (~2,100 hidden elements). Build them the first time a shopper reaches a breed field
// or opens the drawer instead. End state is identical to before.
(function () {
  var built = false;
  function buildBreeds() { if (built) return; built = true; initBreedSelectors(); }
  window.gjBuildBreeds = buildBreeds;
  document.addEventListener('focusin', function (e) { if (e.target && e.target.closest && e.target.closest('.search-wrap')) buildBreeds(); }, true);
  document.addEventListener('pointerdown', function (e) { if (e.target && e.target.closest && e.target.closest('.search-wrap')) buildBreeds(); }, true);
  openTriggers.forEach(function (t) { t.addEventListener('click', buildBreeds); });
})();
checkboxListener();
setSelectState();

// Check local storage to see if a pet should be selected and select that pet if so
if (savedPets) {
  let selectedPet = localStorage.getItem('selectedPet');
  if (selectedPet) {
    let inputValue = '[data-pet-id="' + selectedPet + '"]';
    let activeOption = selectModal.querySelector(inputValue);
    if (activeOption) {
      activeOption.click();
      let selectedOption = document.querySelector(
        '.pet-selector[data-checked="true"]'
      );
      let selectedValue = selectedOption.value;
      if (nameTrigger) {
        nameTrigger.textContent = selectedValue;
        if (namePropInput) {
          namePropInput.value = selectedValue;
          namePropInput.name = 'properties[_Dog Name]';
        }
      }
      let weightFormName = document.querySelector('.form-weight-pet');
      if (weightFormName) {
        weightFormName.textContent = selectedValue;
        let selectedParent = selectedOption.closest('.pet-name-option');
        let selectedWeight = selectedParent.querySelector('.pet-weight');
        selectedWeight = selectedWeight.textContent.split(' ');
        selectedWeight = parseInt(selectedWeight[0]);
        let rangeParent = weightFormName.closest('.form-option-sim');
        let weightMismatchNames =
          rangeParent.querySelectorAll('.weight-apply-name');
        weightMismatchNames.forEach((name) => {
          name.textContent = selectedValue;
        });
        let rangeInput = rangeParent.querySelector('input[type="range"]');
        rangeInput.value = selectedWeight;
        rangeInput.setAttribute('data-selected-pet-weight', selectedWeight);
        let rangeDisplayValue = rangeParent.querySelector(
          '.weight-range-value'
        );
        rangeDisplayValue.textContent = selectedWeight;
        let change = new Event('change');
        rangeInput.dispatchEvent(change);
        if (selectedWeight > 39) {
          enableTopperOption();
        } else {
          disableTopperOption();
        }
      }
    } else {
      localStorage.removeItem('selectedPet');
    }
  }
}

let emailForms = [];

// Find all forms on page and add event listener to forms with email field
let forms = document.querySelectorAll('form');
for (let i = 0; i < forms.length; i++) {
  let form = forms[i];
  let ignoreForms = ['customer_login', 'customer_recover'];
  let emailInput = form.querySelector('input[type="email"]');
  if (!ignoreForms.includes(form.id) && emailInput) {
    emailForms.push(form);
  }
}

// emailForms.forEach((form) => {
//   form.addEventListener('submit', function () {
//     console.log('Televet form submitted');
//     window.onbeforeunload(function () {
//       localStorage.setItem('profileSyncPending', 'true');
//     });
//   });
// });

function clearStoredProfile() {
  localStorage.removeItem('petProfiles');
  localStorage.removeItem('selectedPet');
}

let logOut = document.getElementById('customer_logout_link');
if (logOut) {
  logOut.addEventListener('click', clearStoredProfile);
}

// Sync local storage pet data to customer metafield: {{ customer.metafields.profile.pets }}
function profileSync() {
  /* Oct 23 (Noibu #363): petProfiles can be missing, which threw on Save and left the button dead */
  let stored = null;
  try { stored = JSON.parse(localStorage.getItem('petProfiles') || 'null'); } catch (e) { stored = null; }
  if (!stored || !Array.isArray(stored.pets)) return;
  let metafieldContent = stored.pets;
  localStorage.setItem('customerCartSync', 'true');
  localStorage.setItem(
    'customerCartSyncAttributes',
    JSON.stringify(metafieldContent)
  );
  handleCartSync({ pet_profiles: metafieldContent });
  if (customerId) {
    metafieldContent = JSON.stringify(metafieldContent);

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let body = {
      customerID: customerId,
      metafieldContent: metafieldContent
    };

    const options = {
      method: 'POST',
      headers,
      mode: 'cors',
      body: JSON.stringify(body)
    };

    /* Oct 23 (Noibu #230): this Pipedream endpoint returns 404, so the account copy never updates. Pets still save on this
       device and to the cart; the request is now fire-and-forget so a failure can't break the page. Needs a new endpoint. */
    try {
      fetch('https://enu31tivv8qflp8.m.pipedream.net', options)
        .then(function (response) {
          if (!response.ok) console.warn('Pet profile account sync unavailable (' + response.status + ')');
        })
        .catch(function () {});
    } catch (e) {}
  }
}

let initialSync = localStorage.getItem('profileSyncPending');
if (initialSync === 'true') {
  if (!metafieldPets) {
    profileSync();
  }
  localStorage.removeItem('profileSyncPending');
}

let accountIcons = document.querySelectorAll('.account-icon');
accountIcons.forEach((icon) => {
  icon.addEventListener('click', function () {
    icon.classList.toggle('show-actions');
    window.addEventListener('scroll', function () {
      icon.classList.remove('show-actions');
    });
  });
});

// Highlight table stuff

document.addEventListener('DOMContentLoaded', function () {
  let tableWrappers = document.querySelectorAll('.options-table-shell');
  tableWrappers.forEach((table) => {
    let adultToggle = table.querySelector('.option-category-adult');
    let puppyToggle = table.querySelector('.option-category-puppy');

    function toggleHighlight() {
      adultToggle.classList.remove('toggle-selected');
      if (puppyToggle) {
        puppyToggle.classList.remove('toggle-selected');
      }
      let cells = table.querySelectorAll('td, th');
      cells.forEach((cell) => {
        cell.classList.remove('highlight-basic');
      });
      let rows = table.querySelectorAll('tr, thead');
      this.classList.add('toggle-selected');
      rows.forEach((row) => {
        let cells = row.querySelectorAll('td, th');
        for (let i = 0; i < cells.length; i++) {
          if (this === adultToggle) {
            if (i === 1 || i === 2) {
              cells[i].classList.add('highlight-basic');
            }
          } else {
            if (i === 3 || i === 4) {
              cells[i].classList.add('highlight-basic');
            }
          }
        }
      });
    }

    if (adultToggle) {
      adultToggle.addEventListener('click', toggleHighlight);
    }
    if (puppyToggle) {
      puppyToggle.addEventListener('click', toggleHighlight);
    }
  });
});
